import { defineComponent } from "vue";

import { Days } from "../../../enums/enums";
import { WeeklyMeetingDays } from "../../../enums/WeeklyMeetingDaysEnum";
import { enumToMap } from "../../../common/vue-helpers/modifiers/enum-modifiers";

export default defineComponent({
    props: {
        selectedDaysString: { type: String, default: "" },
        initValue: { type: Array<string>, default: [] },
        isForMeetingCalendar: { type: Boolean, default: false }
    },

    emits: ["updateSelectedDays"],

    data() {
        return {
            selectedDays: [] as string[],
            days: Array.from(Days.enumWithDescriptions.values()) as any,
            enumToMap
        };
    },

    mounted() {
        if (this.isForMeetingCalendar) {
            this.days = Array.from(WeeklyMeetingDays.enumWithDescriptions.values());
        }
        if (this.initValue.length > 0) {
            // initialized selectedDays with existing values if any
            this.selectedDays = [...this.initValue];
        }
    },

    methods: {
        handleDaySelect(value: any) {
            if (this.selectedDays.includes(value)) {
                const index = this.selectedDays.indexOf(value);
                this.selectedDays.splice(index, 1);
            } else {
                this.selectedDays.push(value);
            }
            this.$emit("updateSelectedDays", this.selectedDays.toString());
        }
    }
});
